import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { styleSheet } from './styles';

export const BlogPostContentPreview = ({
	title,
	content,
}: {
	title: string;
	content: Api.IRawRichTextContentState;
}) => {
	if (!content) {
		return null;
	}
	const _content = content.document;

	return (
		<section className={css(styleSheet.previewSection)}>
			<h2 className={css(styleSheet.subTitle)}>AI Blog Preview</h2>
			<p className={css(styleSheet.tagline)}>
				This content will be used as the first blog. Subsequent results may vary.
			</p>

			<div className={css(styleSheet.formControlWrap)}>
				<label>Title:</label>
				<h3>{title}</h3>
			</div>
			<div className={css(styleSheet.formControlWrap)}>
				<label>Blog Content:</label>
				<div dangerouslySetInnerHTML={{ __html: _content }} />
			</div>
		</section>
	);
};
